import { render, staticRenderFns } from "./BusDataSyncUopDocDetailSetList.vue?vue&type=template&id=2471d580&scoped=true&"
import script from "./BusDataSyncUopDocDetailSetList.vue?vue&type=script&lang=js&"
export * from "./BusDataSyncUopDocDetailSetList.vue?vue&type=script&lang=js&"
import style0 from "./BusDataSyncUopDocDetailSetList.vue?vue&type=style&index=0&id=2471d580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471d580",
  null
  
)

export default component.exports